export default "__VITE_ASSET__k27Qs5i$__"